<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import Modal from '../General/Modal.vue';
import { computed } from 'vue';
import isaacReconnecting from '../../assets/base64/isaacReconnecting.ts';
import { useSignalRStore } from '../../stores';

const signalr = useSignalRStore()
const modalShow = computed<boolean>(() => !signalr.isConnected)

const { t } = useI18n()
</script>

<template>
    <Modal v-model="modalShow" :static="true" :close-btn="false" :transparent="true" size="medium" class="!z-50">
        <template #backdrop>
            <div class="fixed inset-0 bg-black/90"></div>
        </template>
        <div class="flex flex-col items-center gap-3 select-none">
            <img :src="isaacReconnecting" class="w-60" />
            <div class="text-white">{{ t(TEXT.network_error) }}</div>
        </div>
    </Modal>
</template>